import { useEffect } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { useBilling } from "../lib/billing";

export function PayMethodSelect({ value, onChange, testid }) {
  const b = useBilling();
  const keys = Object.keys(b?.methods || {});
  useEffect(() => { if (keys.length && !keys.includes(value)) onChange(keys[0]); }, [keys.join(), value]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!b) return null;
  return (
    <Select value={value} onValueChange={onChange}><SelectTrigger data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>{keys.map((k) => <SelectItem key={k} value={k} data-testid={`pay-option-${k}`}>{b.methods[k].label}</SelectItem>)}</SelectContent></Select>
  );
}

export function PayInfo({ method, testid = "payment-instructions", className = "" }) {
  const b = useBilling();
  const m = b?.methods?.[method];
  if (!m?.info) return null;
  return (
    <div className={`text-xs rounded-md bg-amber-500/10 border border-amber-500/30 text-amber-200 p-3 whitespace-pre-line ${className}`} data-testid={testid}>{m.info}
      {m.link && <a href={m.link} target="_blank" rel="noopener noreferrer" data-testid="paypal-pay-btn" className="mt-3 flex w-fit items-center rounded-full bg-[#FFC439] text-[#003087] font-extrabold px-5 py-2 hover:brightness-95 transition">Pay with PayPal</a>}</div>
  );
}
